import axios from "axios";

const BASE_URL = `${process.env.REACT_APP_API_URL}api/`;
const publicApi = axios.create({ baseURL: BASE_URL });

export const fetchIntranetAuth = async (data) => {
  try {
    const response = await publicApi.post("clients/intranet/auth/", data, {
      headers: { "Content-Type": "application/json" },
    });
    return response.data;
  } catch (error) {
    console.error("Erro ao autenticar na intranet:", error.response || error);
    throw error;
  }
};
